import { render, staticRenderFns } from "./RolesCell.vue?vue&type=template&id=f7570f70&"
import script from "./RolesCell.vue?vue&type=script&lang=js&"
export * from "./RolesCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports